// Scroll reveal: anything marked .ss-reveal rises in the first time it scrolls into view. Elements that arrive
// together (a row of cards) are staggered. With reduced motion, no IntersectionObserver or the theme editor open,
// everything is simply shown.
(() => {
  const items = Array.from(document.querySelectorAll('.ss-reveal'));
  if (items.length === 0) return;

  const showAll = () => items.forEach((el) => el.classList.add('is-visible'));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
    showAll();
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left)
        .forEach((entry, i) => {
          entry.target.style.setProperty('--ss-delay', `${i * 110}ms`);
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
    },
    { threshold: 0.18, rootMargin: '0px 0px -6% 0px' },
  );
  items.forEach((el) => io.observe(el));
})();
